import React, { PureComponent } from 'react'
import { Table, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import SourceChannelModalPage from '../../../containers/masters/SourceChannelModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class EntityMasters extends PureComponent {
  componentDidMount () {
    this.props.actions.fetchEntityMasters()
  }

  render () {
    const {
      t, sourceChannelList,
      actions: { deleteSourceChannelModal, openSourceChannelModal }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'entityMastersPage' })
    // const tKey = 'MASTERS.ENTITY_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    return (
      <div id='EntityMasters' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openSourceChannelModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>

          </div>
          <div className='filters'>
            <div className="search-form">

            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th>{t('MASTERS.ID')}</th>
                    <th>{t('MASTERS.NAME')}</th>
                    <th>{t('MASTERS.DESCRIPTION')}</th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {sourceChannelList.map((sourceChannel, idx) => (
                    <tr key={idx}>
                      <td>{sourceChannel.sourceChannelId}</td>
                      <td>{sourceChannel.name}</td>
                      <td>{sourceChannel.description}</td>
                      <td className='actions'>
                        <div>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <a className='_Btn accept stk o-icn ' onClick={() => openSourceChannelModal(sourceChannel.sourceChannelId)}>
                              <i className="iDocIcon-edit" />
                            </a>
                          </OverlayTrigger>
                          <OverlayTrigger placement="left" overlay={deleteTooltip}>
                            <a className='_Btn cancel stk o-icn ' onClick={() => deleteSourceChannelModal(sourceChannel.sourceChannelId)}>
                              <i className="iDocIcon-delete-forever" />
                            </a>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <SourceChannelModalPage />
      </div>
    )
  }
}

export default EntityMasters
